import { Route } from '@angular/router'
import { authGuard } from '@baboor/baboor-auth'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type ProfileRoutes = {
    profile: Route
    clientProfile: Route
}

export const profileRoutes: ProfileRoutes = {
    profile: {
        path: 'profile',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('../page-profile/page-profile.component').then(
                (m) => m.PageProfileComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    clientProfile: {
        path: 'client/profile',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('../page-profile/page-profile.component').then(
                (m) => m.PageProfileComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },
}
